import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Calendar from "../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json"

class Complicanze extends Component {
    state = {
        complicanze: {
            encefalopatia: "",
            trapiantoFegato: "",
            decesso: "",
            causaDecesso: "",
            dataDecesso: ""
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.pulisciValori = this.pulisciValori.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let newState = this.state.complicanze;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.complicanze) {
            let complicanzeCopia = this.props.segnalazioneCopia.schedaSpeciale.complicanze;
            newState.encefalopatia = complicanzeCopia.encefalopatia ? complicanzeCopia.encefalopatia : "";
            newState.trapiantoFegato = complicanzeCopia.trapiantoFegato ? complicanzeCopia.trapiantoFegato : "";
            newState.decesso = complicanzeCopia.decesso ? complicanzeCopia.decesso : "";
            newState.causaDecesso = complicanzeCopia.causaDecesso ? complicanzeCopia.causaDecesso : "";
            newState.dataDecesso = complicanzeCopia.dataDecesso ? complicanzeCopia.dataDecesso : "";
            this.setState({complicanze: newState});
        }
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.complicanze}, "corretto"))
        this.props.setStatePadre(newState, "complicanze", objectForBackend, this.validate())
    }

    riceviValoreInput(field, event) {
        let newState = this.state.complicanze;
        if (field && field.target && field.target.id) {
            newState[field.target.id] = field.target.value;
        } else {
            newState[field] = event.target.value;
        }
        let newStatePulito = this.pulisciValori(newState);
        this.setState({complicanze: newStatePulito})
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.complicanze}, "corretto"))
        this.props.setStatePadre(newStatePulito, "complicanze", objectForBackend, this.validate())
    }

    pulisciValori(state) {
        if ((state.decesso && state.decesso !== "01") || !state.decesso) {
            state.dataDecesso = "";
            state.causaDecesso = "";
        }
        return state;

    }

    validate() {

        if (this.state.complicanze.dataDecesso) {
            let validatedataDecesso = Utils.checkDateInterval(this.state.complicanze.dataDecesso, "31/12/1899");
            let validatedataDecessoOdierna = Utils.checkDateInterval(this.state.complicanze.dataDecesso, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataDecesso) {
                return "Messages.DataDecesso"
            } else if (!validatedataDecessoOdierna) {
                return "Messages.DataDecessoOdierna"
            }
        }
        return ""
    }

    controlloDati() {
        let complicanze = this.state.complicanze;
        complicanze.corretto = [];

        if (!complicanze.decesso) complicanze.corretto[0] = "Campo \"Decesso\" mancante";
        if (complicanze.dataDecesso && (Utils.isDateInValid(Utils.transformDateForBackend(complicanze.dataDecesso), "-"))) complicanze.corretto[4] = "Campo \"Data decesso\" errato";
        this.setState({complicanze: complicanze})

    }


    render() {
        const {t} = this.props
        return (
            <div>
                <div style={{marginTop: "10px"}}/>
                <div><h6>Complicanze</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-12 mt-1"}>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Complicanze.encefalopatia")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"encefalopatiaSi"}
                                                     name={"encefalopatia"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.complicanze.encefalopatia === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"encefalopatiaNo"}
                                                     name={"encefalopatia"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.complicanze.encefalopatia === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"encefalopatiaNonSo"}
                                                     name={"encefalopatia"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.complicanze.encefalopatia === "03"}
                                        />
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Complicanze.trapiantoFegato")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"trapiantoFegatoSi"}
                                                     name={"trapiantoFegato"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.complicanze.trapiantoFegato === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"trapiantoFegatoNo"}
                                                     name={"trapiantoFegato"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.complicanze.trapiantoFegato === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"trapiantoFegatoNonSo"}
                                                     name={"trapiantoFegato"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.complicanze.trapiantoFegato === "03"}
                                        />
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Complicanze.decesso")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"decessoSi"}
                                                         name={"decesso"}
                                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.complicanze.decesso === "01"}
                                            />
                                            <RadioButton id={"decessoNo"}
                                                         name={"decesso"}
                                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.complicanze.decesso === "02"}
                                            />
                                            <RadioButton id={"decessoNonSo"}
                                                         name={"decesso"}
                                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.complicanze.decesso === "03"}
                                            />
                                        </div>
                                    </div>
                                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Complicanze.causaDecesso")}
                                        </p>
                                        <Input
                                            id={"causaDecesso"}
                                            onChange={this.riceviValoreInput}
                                            field={"causaDecesso"}
                                            value={this.state.complicanze.causaDecesso}
                                            disabled={!this.state.complicanze.decesso || this.state.complicanze.decesso !== "01"}
                                            placeholder={"Causa decesso"}
                                        />
                                    </div>
                                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.Complicanze.dataDecesso")}
                                        </p>
                                        <Calendar
                                            id={"dataDecesso"}
                                            field={"dataDecesso"}
                                            value={this.state.complicanze.dataDecesso}
                                            onChange={this.riceviValoreInput}
                                            disabled={!this.state.complicanze.decesso || this.state.complicanze.decesso !== "01"}
                                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                                "Data")}
                                            error={(this.state.complicanze.dataDecesso === "" ||
                                                this.state.complicanze.dataDecesso == null) ? false :
                                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.complicanze.dataDecesso), "-")}
                                        >
                                        </Calendar>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default withTranslation('common')(Complicanze)
